import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'agency_location_rate_settings',
  inputShow: gql`
    query agencyLocationRateSettings($input: RateSettingQueryInput) {
      agencyLocationRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Agency Location Rate Settings',
    order: 7,
  },
};
